<template>
    <div class="file-name-textarea">
        <label class="label">
            {{ $t(titleLabel) }}<Tooltip :text="tooltip || titleLabel"><i
                    class="ag-icon ag-icon_table_info small info-icon" /></Tooltip>
        </label>
        <textarea class="path-textarea" :placeholder="placeholder" rows="1" v-model="localValue"
            ref="textareaRef" @input="onInput" :class="{ 'invalid': isInvalid || overLimit }" :disabled="disabled"></textarea>
        <div class="counter d-flex"><p :class="{ 'over': overLimit }" style="margin-right: 5px;">{{ charCount }} </p>  <p> / {{ maxLength }}</p> </div>
        <div v-if="isInvalid && errorMessage" class="error-text">{{ errorMessage }}</div>
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits, ref, onMounted, nextTick, watch } from 'vue'
import Tooltip from './tooltip.vue'
const props = defineProps({
    titleLabel: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    modelValue: { type: String, default: '' },
    maxLength: { type: Number, default: 260 },
    tooltip: { type: String, default: '' },
    errorMessage: { type: String, default: '' },
    isInvalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'validation'])

const localValue = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const charCount = computed(() => (localValue.value || '').length)
const overLimit = computed(() => charCount.value > props.maxLength)

const textareaRef = ref(null)
const autoResize = () => {
    const el = textareaRef.value
    if (!el) return
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
}

const onInput = () => {
    autoResize()
    emit('validation', !overLimit.value && !props.isInvalid)
}

onMounted(() => {
    nextTick(() => autoResize())
})

watch(localValue, () => {
    nextTick(() => autoResize())
    emit('validation', !overLimit.value && !props.isInvalid)
})
</script>

<style scoped>
.file-name-textarea {
    width: 100%;
}

.label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    color: #164B6C;
    font-weight: 700;
}

.title {
    color: #164B6C;
    font-weight: 700;
}

.optional {
    color: #6b7280;
    font-size: 0.85em;
}

.info-icon {
    color: #6c757d;
    margin-left: 0px;
    display: inline-flex;
    align-items: center;
}

.path-textarea {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px;
    font-size: 0.8rem;
    resize: none;
    overflow: hidden;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.path-textarea.invalid {
    border-color: #dc3545;
}

.path-textarea:focus,
.path-textarea:focus-visible {
    outline: none;
    box-shadow: none;
    border-color: #cbd5e1;
}

.path-textarea::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.path-textarea::-webkit-scrollbar-track {
    background: transparent;
}

.path-textarea::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
}

.path-textarea::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}

.counter {
    text-align: right;
    color: #6b7280;
    font-size: 0.70rem;
    justify-content: end;
}

.counter .over {
    color: #dc3545;
}

.error-text {
    color: #dc3545;
    font-size: 0.70rem;
}
.counter p{
    margin-bottom: 0;
}
</style>